import { MessageCircle } from "lucide-react";
import { BRAND, CONTACT, WHATSAPP_DISPLAY, waLink, MESSAGES, NAV_LINKS } from "@/data/site";
import { useLang } from "@/i18n";

const Footer = () => {
  const t = useLang().t;
  return (
  <footer data-testid="footer" className="bg-[#3E2723] text-[#F5F2EB]">
    <div className="container-site py-14 sm:py-16">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt="Disign Digital logo" className="h-11 w-11 rounded-full object-cover" />
            <div>
              <p className="font-heading text-xl font-bold lowercase">designdigital</p>
              <p className="text-sm text-[#D7B594]">{t.footer.tagline}</p>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-[#E7DED2]/80">
            {t.footer.desc}
          </p>
        </div>
        <div>
          <p className="font-heading text-base font-semibold text-[#D7B594]">{t.footer.explore}</p>
          <div className="mt-4 grid grid-cols-2 gap-2">
            {NAV_LINKS.map((l, i) => (
              <a
                key={l.href}
                href={l.href}
                className="text-sm text-[#E7DED2]/80 transition-colors duration-200 hover:text-white"
              >
                {t.nav.links[i]}
              </a>
            ))}
          </div>
        </div>
        <div>
          <p className="font-heading text-base font-semibold text-[#D7B594]">{t.footer.contact}</p>
          <p className="mt-4 text-sm text-[#E7DED2]/80">
            {CONTACT.name}
            <br />
            {CONTACT.role}
          </p>
          <a
            href={waLink(MESSAGES.generic)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-[#25D366] hover:text-white transition-colors duration-200"
          >
            <MessageCircle className="h-4 w-4" /> {t.contact.whatsappLabel} {WHATSAPP_DISPLAY}
          </a>
          <p className="mt-3 text-sm text-[#E7DED2]/60">{BRAND.domain}</p>
        </div>
      </div>
      <div className="mt-12 border-t border-white/10 pt-6 text-center text-xs text-[#E7DED2]/50">
        © {new Date().getFullYear()} Disign Digital · {BRAND.domain} · {BRAND.tagline}
      </div>
    </div>
  </footer>
  );
};

export default Footer;
